import DocPage from "../components/DocPage";
import { Link } from "react-router";

function LegalPage() {
  return (
    <DocPage
      eyebrow="Legal"
      title="Website terms"
      lede="These terms govern use of the SimFinance website. They are an overview of how this site should be used, not a substitute for a signed commercial agreement."
    >
      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">Who we are</h2>
        <p className="mt-2">
          SimFinance is a financial technology company and ecosystem. It is not a bank. The platform connects
          consumers with verified financial institutions and provides technology solutions to the financial
          services industry.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">Informational use</h2>
        <p className="mt-2">
          Content on this website is for general information. It is not an offer of credit, insurance, investment,
          or other regulated financial products, and it is not financial, legal, or credit advice. Product
          availability depends on the relevant institution and applicable regulation.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">Intellectual property</h2>
        <p className="mt-2">
          SimFinance, SimMarket, SimVerify, SimCollect, and related marks, copy, and visuals on this site are
          owned by SimFinance or used with permission. You may not copy, scrape, or reuse them for commercial
          purposes without written consent.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">Acceptable use</h2>
        <p className="mt-2">
          Do not misuse the site, attempt unauthorized access, or submit false information through our forms.
          We may suspend access where we reasonably believe these terms have been breached.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">Liability</h2>
        <p className="mt-2">
          The website is provided as a marketing and information channel. To the extent permitted by law,
          SimFinance is not liable for losses arising from reliance on website content alone. Institution
          relationships and product terms are governed by separate agreements.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold tracking-tight text-navy">Privacy</h2>
        <p className="mt-2">
          How we handle information submitted through this website is described in our{" "}
          <Link
            to="/privacy"
            className="font-semibold text-navy underline decoration-gold/80 underline-offset-[5px] hover:decoration-gold"
          >
            Privacy Policy
          </Link>
          .
        </p>
      </section>
    </DocPage>
  );
}

export default LegalPage;
